import { RealityCheckMessageChannels } from "../message";
export const QueryTypes = RealityCheckMessageChannels;
//# sourceMappingURL=realityCheck.js.map